module.exports = __webpack_public_path__ + "static/media/howItWorks2-mobile.7a5d8cd8.png";